import React from 'react';
import ReactGA from 'react-ga';
import './LandingPage.css';
import './LandingPage.desktop.css';
import './LandingPage.mobile.css';
import ExplorerContainer from './ExplorerContainer';
import { decodeHash, decodeNumber, getToken, hexToRgb } from '../libs/utils';
import Lobby from '../components/lobby';
import { LandingPageConfiguration } from '../types/landingPage';
import { io } from 'socket.io-client';
import { GlobalVars } from '../libs/utils';
import VideoChat from '../components/VideoChat';
import { disable, enable } from '../libs/marzipano';
import { Language } from '../components/language';
import { ReactComponent as AliveVisionSVG } from '../svg/alive_vision_by_3decide_whiteLogomarca.svg';
import { ReactComponent as BackButtonSVG } from '../icon/back.svg';
import { ReactComponent as EmailSVG } from '../icon/email.svg';
import { ReactComponent as PhoneSVG } from '../icon/phone.svg';
import { ReactComponent as WebSVG } from '../icon/world.svg';
import { ReactComponent as CloseSVG } from '../icon/close.svg';
import { ReactComponent as SunSVG } from '../icon/sun.svg';
import { ReactComponent as MoonSVG } from '../icon/dark_mode.svg';
import { ReactComponent as BackSVG } from '../icon/back-oval.svg';
//import Marzipano from './MarzipanoViewer';
//import 'int_sdk_viewer3d/dist/index.css';
//const MyComponent = require('int_sdk_viewer3d').default;

interface LandingPageState {
  startingMapping: string | null;
  orientation: number | string;
  height: string;
  language: string | undefined;
  bgIndex?: number;
  description?: string;
  page: number;
  showMoreInfo: boolean;
  night?: boolean;
  live: boolean;
  lobby: boolean;
  controlling: boolean;
  videochat: boolean;
  user?: any;
  limitReached: boolean;
  blocked: boolean;
}

export default class LandingPage extends React.Component {
  height = '100vh';

  state: LandingPageState = {
    startingMapping: null,
    orientation: window.orientation,
    height: this.height,
    language: undefined,
    bgIndex: 0,
    page: 0,
    showMoreInfo: false,
    live: false,
    lobby: false,
    controlling: false,
    videochat: false,
    user: undefined,
    limitReached: false,
    blocked: false,
  };

  svgRef = React.createRef<SVGSVGElement>();

  componentDidMount = () => {
    let favicon: any = document.getElementById('favicon');
    if (favicon) favicon.href = './assets/img/valsteam_logo_color.png';
    sessionStorage.clear();
    const landingPageConfig: LandingPageConfiguration = require('../JSON/landing_page.json');
    document.title = landingPageConfig.webTitle;
    if (landingPageConfig.toggleDayNight) {
      this.toggleNight(false);
    }
    if (landingPageConfig.color) {
      if (landingPageConfig.color.main.startsWith('#')) {
        const rgb = hexToRgb(landingPageConfig.color.main);
        document.documentElement.style.setProperty(
          '--main-color',
          rgb.r + ',' + rgb.g + ',' + rgb.b,
        );
      } else {
        document.documentElement.style.setProperty('--main-color', landingPageConfig.color.main);
      }
      if (landingPageConfig.color.dark.startsWith('#')) {
        const rgb = hexToRgb(landingPageConfig.color.dark);
        document.documentElement.style.setProperty(
          '--main-dark',
          rgb.r + ',' + rgb.g + ',' + rgb.b,
        );
      } else {
        document.documentElement.style.setProperty('--main-dark', landingPageConfig.color.dark);
      }
    }
    window.addEventListener('closeCall', () => {
      if (GlobalVars.socket && GlobalVars.admin) {
        GlobalVars.socket.emit('startLive', false);
        //GlobalVars.socket.emit('leaveRoom', GlobalVars.room);
      }
      //GlobalVars.room = undefined;
      GlobalVars.controller = undefined;
      const changeControllerEvent = new Event('changeController');
      window.dispatchEvent(changeControllerEvent);
      this.setLive(false);
      this.setCall(false, () => {
        GlobalVars.reset();
        if (window.location.search) {
          window.history.replaceState({}, document.title, '/');
        }
        enable();
      });
    });
    window.addEventListener('stopLive', () => {
      if (GlobalVars.socket) {
        GlobalVars.socket.emit('startLive', false);
        //GlobalVars.socket.emit('leaveRoom', GlobalVars.room);
      }
      //GlobalVars.room = undefined;
      GlobalVars.controller = undefined;
      const changeControllerEvent = new Event('changeController');
      window.dispatchEvent(changeControllerEvent);
      this.setLive(false);
    });
    window.addEventListener('groupCall', () => {
      const bearer = 'Bearer ' + getToken();
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: bearer },
      };
      fetch('https://twilio.alive.vision/api/user', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          this.setState({ user: data });
          this.setCall(true);
        });
    });
    window.addEventListener('changeController', () => {
      if (GlobalVars.socket && this.state.live) {
        this.setState({ controlling: GlobalVars.controller });
      }
    });
    fetch('./ga/config.json')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        ReactGA.initialize(data.gtag);
        ReactGA.pageview('/');
      })
      .catch(function (err) {
        console.log(err, ' error');
      });

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      let vw = window.innerWidth * 0.01;
      document.documentElement.style.setProperty('--vw', `${vw}px`);
      window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        let vw = window.innerWidth * 0.01;
        document.documentElement.style.setProperty('--vw', `${vw}px`);
      });

      window.onorientationchange = () => {
        const sm = this.state.startingMapping ? this.state.startingMapping : '';
        sessionStorage.setItem('startingMapping', sm);
        this.setState({ orientation: window.orientation });
      };
      if (window.orientation === 0) {
        this.setState({ height: window.innerWidth - 86 + 'px' });
      } else {
        this.setState({ height: window.innerHeight });
      }
    }

    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const lang = urlParams.get('language');
      if (lang) {
        switch (lang) {
          case 'en':
            this.setState({ startingMapping: 'mapping_en.json', language: 'English' });
            break;

          case 'de':
            this.setState({ startingMapping: 'mapping_de.json', language: 'German' });
            break;

          default:
            window.location.replace(window.location.pathname);
            break;
        }
      }
      const code = urlParams.get('loc');
      if (code) {
        const values = decodeHash(code);
        this.setState({ startingMapping: values.mapping + '.json' });
      }
      const liveParam = urlParams.get('live');
      if (liveParam !== undefined && liveParam !== null) {
        const live = decodeNumber(liveParam);
        if (!GlobalVars.socket) {
          GlobalVars.socket = io('https://twilio.alive.vision');
          //GlobalVars.socket = io('http://localhost:3000');
        }
        if (!GlobalVars.socket.connected) {
          GlobalVars.socket.on('connect', () => {
            GlobalVars.socket?.emit('joinRoom', live);
            GlobalVars.room = Number(live);
            GlobalVars.socket?.on('participantsLimitReached', (reached: boolean) => {
              this.setState({ limitReached: reached });
            });
            GlobalVars.socket?.on('startLive', (start: boolean) => {
              this.setLive(start);
            });
            GlobalVars.socket?.on('startingMapping', (mapping: string) => {
              if (!this.state.startingMapping) {
                let mp = mapping;
                if (landingPageConfig.buttons && landingPageConfig.buttons.length > 0 && !mapping) {
                  mp = landingPageConfig.buttons[0].mapping;
                }
                this.setState({ startingMapping: mp });
              } else {
                if (!mapping) {
                  this.setState({ startingMapping: mapping, bgIndex: 0 });
                }
              }
            });
            this.setState({ live: this.state.startingMapping, lobby: true, videochat: true });
          });
        } else {
          GlobalVars.socket?.emit('joinRoom', live);
          GlobalVars.room = Number(live);
          GlobalVars.socket?.on('participantsLimitReached', (reached: boolean) => {
            this.setState({ limitReached: reached });
          });
          GlobalVars.socket?.on('startLive', (start: boolean) => {
            this.setLive(start);
          });
          GlobalVars.socket?.on('startingMapping', (mapping: string) => {
            if (!this.state.startingMapping) {
              let mp = mapping;
              if (landingPageConfig.buttons && landingPageConfig.buttons.length > 0 && !mapping) {
                mp = landingPageConfig.buttons[0].mapping;
              }
              this.setState({ startingMapping: mp });
            } else {
              if (!mapping) {
                this.setState({ startingMapping: mapping, bgIndex: 0 });
              }
            }
          });
          this.setState({ live: this.state.startingMapping, lobby: true, videochat: true });
        }
      }
    }

    if (landingPageConfig.defaultLanguage) {
      this.setState({ language: landingPageConfig.defaultLanguage });
    }
    if (landingPageConfig.backgroundImg) {
      this.setState({ bg: landingPageConfig.backgroundImg });
    }
    if (landingPageConfig.description) {
      this.setState({ description: landingPageConfig.description });
    }

    if (this.svgRef.current) {
      const children: any = this.svgRef.current.children;
      for (let child of children) {
        const info = this.getInfoOf(child.id);
        if (info) {
          child.onclick = () => {
            this.setState({ startingMapping: info.mapping });
          };
        }
      }
    }
  };

  componentDidUpdate = (prevProps: any, prevState: LandingPageState) => {
    if (!prevState.live && this.state.live) {
      if (GlobalVars.socket) {
        GlobalVars.socket.on('startingMapping', (mapping: string) => {
          if (!this.state.startingMapping) {
            this.setState({ startingMapping: mapping });
          }
          if (!mapping) {
            this.setState({ startingMapping: mapping, bgIndex: 0 });
          }
        });
      }
    }
    //const landingPageConfig: LandingPageConfiguration = require('../JSON/landing_page.json');
    if (
      this.state.orientation === 0 &&
      prevState.orientation !== 0 &&
      this.state.height !== window.innerHeight + 'px'
    ) {
      this.setState({ height: window.innerHeight + 'px' });
    }
    if (this.state.startingMapping && this.state.language !== prevState.language) {
      //let configUrl = '.json';
      let mapping = this.state.startingMapping;
      /*switch (prevState.language) {
        case 'English':
          mapping = mapping.replace('_en.json', '');
          break;
        default:
          mapping = mapping.replace('.json', '');
          break;
      }
      switch (this.state.language) {
        case 'English':
          if (landingPageConfig.defaultLanguage === 'English') {
            configUrl = '.json';
          } else {
            configUrl = '_en.json';
          }
          break;
        default:
          configUrl = '.json';
          break;
      }
      mapping += configUrl;*/
      this.setState({ startingMapping: mapping });
    }

    if (this.svgRef.current) {
      const children: any = this.svgRef.current.children;
      for (let child of children) {
        const info = this.getInfoOf(child.id);
        if (info) {
          child.onclick = () => {
            if (this.state.live && this.state.controlling) {
              GlobalVars.socket?.emit('startingMapping', info.mapping);
            }
            this.setState({ startingMapping: info.mapping });
          };
        }
      }
    }
  };

  getInfoOf(id: string) {
    let configUrl: string = '.json';
    /*switch (this.state.language) {
      case 'English':
        configUrl = '_en.json';
        break;
      default:
        configUrl = '.json';
        break;
    }*/
    const landingPageConfig: LandingPageConfiguration = require(`../JSON/landing_page${configUrl}`);

    if (landingPageConfig.floors) {
      for (let floor of landingPageConfig.floors) {
        if (floor.svgId === id) {
          return floor;
        }
      }
    }

    return undefined;
  }

  toggleNight = (night: boolean) => {
    this.setState({ night: night });
  };

  returnToLanding = () => {
    if (this.state.live && this.state.controlling) GlobalVars.socket?.emit('startingMapping', null);
    this.setState({ startingMapping: null, bgIndex: 0 });
  };

  changeLanguage = (newLang: string | undefined) => {
    this.setState({ language: newLang });
  };

  setLive = (live: boolean | null, callback?: CallableFunction) => {
    this.setState({ live: live }, () => {
      if (callback) callback();
    });
  };

  setCall = (call: boolean, callback?: CallableFunction) => {
    this.setState({ videochat: call }, () => {
      if (callback) callback();
    });
  };

  toggleCall = () => {
    this.setState({ videochat: !this.state.videochat });
  };

  enterLive = (name: string) => {
    GlobalVars.identity = name;
    this.setState({ lobby: false });
  };

  render() {
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );

    let exploreCircuits = 'explore os circuitos';
    let exploreSpaces = 'explore os espaços de dia ou noite';
    let aboutCircuits = 'sobre os circuitos';
    let prefixFolder: string = '';
    let configUrl: string = '.json';
    let landingPageConfig: LandingPageConfiguration = require(`../JSON/landing_page${configUrl}`);
    switch (this.state.language) {
      case 'English':
        if (landingPageConfig.defaultLanguage === 'English') {
          configUrl = '.json';
        } else {
          prefixFolder = 'en/';
          configUrl = '_en.json';
        }
        exploreCircuits = 'explore the circuits';
        exploreSpaces = 'explore the venue by day or by night';
        aboutCircuits = 'about the circuits';
        break;
      default:
        configUrl = '.json';
        break;
    }

    landingPageConfig = require(`../JSON/${prefixFolder}landing_page${configUrl}`);

    let content;

    const backgrounds = landingPageConfig.buttons?.map((btn, index) => {
      let background = btn.backgroundImg;
      if (this.state.night && btn.backgroundImgN) {
        background = btn.backgroundImgN;
      }
      if (index + 1 === this.state.bgIndex) {
        return (
          <img
            key={`bg-key-${index + 1}`}
            src={background}
            style={{ opacity: 1, zIndex: 2 }}
            alt=""
          ></img>
        );
      } else {
        return (
          <img
            key={`bg-key-${index + 1}`}
            src={background}
            style={{ opacity: 0, zIndex: 1 }}
            alt=""
          ></img>
        );
      }
    });

    const brightness = this.state.bgIndex === 0 ? '' : 'brightness(0%)';
    backgrounds?.unshift(
      <img
        key={`bg-key-0`}
        src={
          this.state.night ? landingPageConfig.nightBackgroundImg : landingPageConfig.backgroundImg
        }
        style={{ opacity: 1, filter: brightness, zIndex: 0, transition: 'filter 0.3s ease-in' }}
        alt=""
      ></img>,
    );

    let description;
    if (landingPageConfig.buttons && this.state.bgIndex !== undefined) {
      description =
        this.state.bgIndex === 0
          ? landingPageConfig.description
          : landingPageConfig.buttons[this.state.bgIndex - 1].description;
    }

    const circuits = landingPageConfig.buttons?.map((c) => {
      return { name: c.name, mapping: c.mapping };
    });

    let dayOpacity = this.state.night === false ? 1 : 0;
    let nightOpacity = this.state.night ? 1 : 0;

    if (this.state.limitReached) {
      return (
        <>
          <div className="limit-reached">
            Limite de participantes ultrapassado, não pode participar na chamada
          </div>
        </>
      );
    }

    const buttons = landingPageConfig.buttons?.map((btn, index) => {
      const style =
        this.state.bgIndex && index !== this.state.bgIndex - 1 ? { opacity: 0.4 } : { opacity: 1 };
      return (
        <div
          style={style}
          key={`btn-lp-${index}`}
          className="start"
          onClick={() => {
            if (this.state.live && this.state.controlling && GlobalVars.socket) {
              GlobalVars.socket.emit('startingMapping', btn.mapping);
            }
            this.setState({ startingMapping: btn.mapping });
          }}
          onMouseEnter={() => {
            this.setState({ bgIndex: index + 1 });
          }}
          onMouseOut={() => {
            this.setState({ bgIndex: 0 });
          }}
        >
          <svg>
            <line x1="0" y1="0" x2="100" y2="0" />
          </svg>
          {btn.name}
        </div>
      );
    });

    if (this.state.live) disable();
    if (mobile && !this.state.startingMapping) {
      const landing = (
        <div className={this.state.orientation === 0 ? 'portrait' : 'landscape'}>
          <div className="background">
            <div className="brightness-layer"></div>
            <img src={landingPageConfig.backgroundImg} alt=""></img>
          </div>
          <img className="logo" src={landingPageConfig.logo} alt=""></img>
          <div
            className="explore-btn"
            onClick={() => {
              this.setState({ page: 1 });
            }}
          >
            EXPLORAR
          </div>
          <div
            className="moreInfo"
            onClick={() => {
              this.setState({ showMoreInfo: true });
            }}
          >
            Mais Informações
          </div>
          <div
            className="moreInfoContent"
            onClick={() => {
              this.setState({ showMoreInfo: false });
            }}
            style={this.state.showMoreInfo ? { opacity: 1, pointerEvents: 'all' } : {}}
          >
            <div
              className="contentWrapper"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <CloseSVG
                onClick={() => {
                  this.setState({ showMoreInfo: false });
                }}
              />
              <h1>Contactos</h1>
              <p
                onClick={() => {
                  window.open('mailto:geral@quintadoalferes.pt');
                }}
              >
                <EmailSVG />
                {' geral@quintadoalferes.pt'}
              </p>
              <p
                style={{ marginBottom: '32px' }}
                onClick={() => {
                  window.open('tel:+351916241496');
                }}
              >
                <PhoneSVG />
                {' +351 916 241 496'}
              </p>
              <h1>Visite o nosso site</h1>
              <p
                onClick={() => {
                  window.open('http://quintadoalferes.pt');
                }}
              >
                <WebSVG />
                {' quintadoalferes.pt'}
              </p>
              <div className="poweredBy">
                powered by
                <AliveVisionSVG />
              </div>
            </div>
          </div>
        </div>
      );

      const imgLinks = landingPageConfig.buttons?.map((btn, index) => {
        const mr =
          index + 1 === landingPageConfig.buttons?.length || this.state.orientation === 0
            ? 0
            : '10px';
        return (
          <div
            key={`key-links-${index}`}
            className="img-link"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1)), url(${btn.backgroundImg})`,
              marginRight: mr,
            }}
            onClick={() => this.setState({ startingMapping: btn.mapping })}
          >
            {btn.description ? (
              <p>{btn.description}</p>
            ) : (
              <div>
                <h2>{''}</h2>
                <p>{btn.artists}</p>
              </div>
            )}
            <h1>{btn.name}</h1>
          </div>
        );
      });

      const links = (
        <div className={this.state.orientation === 0 ? 'portrait-links' : 'landscape-links'}>
          <BackButtonSVG
            onClick={() => {
              this.setState({ page: 0 });
            }}
          />
          <div className="wrapper">{imgLinks}</div>
        </div>
      );

      let pageContent = this.state.page ? links : landing;

      return !this.state.startingMapping ? (
        pageContent
      ) : (
        <ExplorerContainer
          key="ec"
          startingMapping={this.state.startingMapping}
          backFunction={this.returnToLanding}
          logo={landingPageConfig.logo}
          changeLanguage={
            landingPageConfig.languages && landingPageConfig.languages?.length > 0
              ? this.changeLanguage
              : undefined
          }
          languages={landingPageConfig.languages}
          language={this.state.language}
          aliveVision={landingPageConfig.aliveVision}
          showPartners={landingPageConfig.showPartners}
          orientation={this.state.orientation}
          webTitle={landingPageConfig.title ? landingPageConfig.title : landingPageConfig.webTitle}
          toggleNight={this.toggleNight}
          night={this.state.night}
          dropdownCircuits={landingPageConfig.dropdownCircuits}
          circuits={circuits}
          enableLiveMode={landingPageConfig.enableLiveMode}
          controlling={this.state.controlling}
          live={this.state.live}
          setLive={this.setLive}
          videochat={this.state.videochat}
        />
      );
    }
    content = !this.state.startingMapping
      ? [
          <div className="landing-page">
            <div className="background">{backgrounds}</div>
            <div className="brightness-layer"></div>
            {landingPageConfig.languages && landingPageConfig.languages.length > 0 ? (
              <Language
                onLanguageSelect={this.changeLanguage}
                languageList={landingPageConfig.languages}
              />
            ) : null}
            <img className="logoC" src={landingPageConfig.logo} alt=""></img>
            <div className="explore-label">
              <svg>
                <line x1="0" y1="0" x2="100" y2="0" />
              </svg>
              {exploreCircuits}
            </div>
            <div className="btn-cont">{buttons}</div>
            <div className="about-label">
              <svg>
                <line x1="0" y1="0" x2="100" y2="0" />
              </svg>
              {aboutCircuits}
            </div>
            <div className="desc">{description}</div>
            <div className="day-night-label">
              <svg>
                <line x1="0" y1="0" x2="100" y2="0" />
              </svg>
              {exploreSpaces}
            </div>
            <div className="day-night-container">
              <div className="day-night-content">
                <SunSVG onClick={() => this.toggleNight(false)} style={{ zIndex: 1 }} />
                <BackSVG style={{ width: '100%', height: '100%', opacity: dayOpacity }} />
              </div>
              <div className="day-night-content">
                <MoonSVG onClick={() => this.toggleNight(true)} style={{ zIndex: 1 }} />
                <BackSVG style={{ width: '100%', height: '100%', opacity: nightOpacity }} />
              </div>
            </div>
            <img
              className="client-logo"
              onClick={() => {
                window.open('https://ilovebrides.pt/');
              }}
              src="/assets/img/logo-love-brides-branco.png"
              alt=""
            ></img>
          </div>,
          this.state.live &&
          !this.state.lobby &&
          !this.state.controlling &&
          GlobalVars.room !== undefined ? (
            <>
              <div
                key="ri"
                className="remote-indicator"
                onClick={() => {
                  this.setState({ blocked: true });
                  setTimeout(() => {
                    this.setState({ blocked: false });
                  }, 3000);
                }}
              ></div>
              {this.state.blocked && (
                <div className="block-background">
                  <div className="block-container">
                    Não é possível controlar a visita enquanto está a ser guiado.
                  </div>
                </div>
              )}
            </>
          ) : null,
          this.state.lobby && !this.state.controlling && GlobalVars.room !== undefined ? (
            <>
              <div className="lobby-bg"></div>
              <Lobby key="lobby-key" startCall={this.enterLive} />
            </>
          ) : null,
          this.state.live && this.state.controlling && GlobalVars.room !== undefined ? (
            <div key="ssi" className="stop-sharing-indicator"></div>
          ) : null,
          this.state.videochat &&
          !this.state.lobby &&
          ((GlobalVars.admin && this.state.user) || !GlobalVars.admin) ? (
            <VideoChat key="vc" live={this.state.live} user={this.state.user} />
          ) : null,
        ]
      : [
          <ExplorerContainer
            key="ec"
            startingMapping={this.state.startingMapping}
            backFunction={this.returnToLanding}
            logo={landingPageConfig.logo}
            changeLanguage={
              landingPageConfig.languages && landingPageConfig.languages?.length > 0
                ? this.changeLanguage
                : undefined
            }
            languages={landingPageConfig.languages}
            language={this.state.language}
            aliveVision={landingPageConfig.aliveVision}
            showPartners={landingPageConfig.showPartners}
            orientation={this.state.orientation}
            webTitle={
              landingPageConfig.title ? landingPageConfig.title : landingPageConfig.webTitle
            }
            toggleNight={this.toggleNight}
            night={this.state.night}
            dropdownCircuits={landingPageConfig.dropdownCircuits}
            circuits={circuits}
            enableLiveMode={landingPageConfig.enableLiveMode}
            controlling={this.state.controlling}
            live={this.state.live}
            setLive={this.setLive}
            videochat={this.state.videochat}
          />,
          this.state.live &&
          !this.state.lobby &&
          !this.state.controlling &&
          GlobalVars.room !== undefined ? (
            <>
              <div
                key="ri"
                className="remote-indicator"
                onClick={() => {
                  this.setState({ blocked: true });
                  setTimeout(() => {
                    this.setState({ blocked: false });
                  }, 3000);
                }}
              ></div>
              {this.state.blocked && (
                <div className="block-background">
                  <div className="block-container">
                    Não é possível controlar a visita enquanto está a ser guiado.
                  </div>
                </div>
              )}
            </>
          ) : null,
          this.state.lobby && !this.state.controlling && GlobalVars.room !== undefined ? (
            <>
              <div className="lobby-bg"></div>
              <Lobby key="lobby-key" startCall={this.enterLive} />
            </>
          ) : null,
          this.state.live && this.state.controlling && GlobalVars.room !== undefined ? (
            <div key="ssi" className="stop-sharing-indicator"></div>
          ) : null,
          this.state.videochat &&
          !this.state.lobby &&
          ((GlobalVars.admin && this.state.user) || !GlobalVars.admin) ? (
            <VideoChat key="vc" live={this.state.live} user={this.state.user} />
          ) : null,
        ];

    return content;
  }
}
